document.addEventListener('DOMContentLoaded', function() {

	/**
	 * Reveal and hide site header on scroll.
	 */
	const siteHeader = document.querySelector('.site-header');
	const siteHeaderShadowClass = 'site-header--shadow';
	const scrollHide = 'scroll-hide';
	const scrollReveal = 'scroll-reveal';
	const scrollDelta = 5;
	let didScroll = false;
	let lastScroll = 0;

	// Event listener for scroll.
	window.addEventListener('scroll', () => {
		didScroll = true;
	});

	// Set interval to not check for scrolling instantly.
	setInterval(function() {
		if (didScroll) {
			handlePageScroll();
			didScroll = false;
		}
	}, 100);

	// Handle page scroll.
	function handlePageScroll() {
		const currentScroll = window.pageYOffset;
		
		if (Math.abs(lastScroll - currentScroll) <= scrollDelta) {
			return;
		}

		if ( currentScroll <= scrollDelta ) {
			// Reached top.
			siteHeader.classList.remove(siteHeaderShadowClass);
			siteHeader.classList.remove(scrollReveal);
		} else if (currentScroll > lastScroll && currentScroll > siteHeader.offsetHeight) {
			// Scrolling down.
			siteHeader.classList.remove(scrollReveal);
			siteHeader.classList.add(scrollHide);
		} else if (currentScroll < lastScroll && siteHeader.classList.contains(scrollHide)) {
			// Scrolling up.
			siteHeader.classList.remove(scrollHide);
			siteHeader.classList.add(scrollReveal);
			siteHeader.classList.add(siteHeaderShadowClass);
		}

		lastScroll = currentScroll;
	}

	// Handle site header search.
	const siteSearchButton = document.querySelector('.site-header__top__search button');
	const siteSearchField = document.querySelector('.site-header__search input[name="s"]');

	siteSearchButton.addEventListener('click', () => {
		siteHeader.classList.toggle('site-header--search-visible');
		siteHeader.classList.remove('site-header--full-nav-visible');
		document.body.classList.toggle('disable-page-scroll');
		siteSearchField.focus();
	});

	// Handle site header full nav.
	const siteFullNavButton = document.querySelector('.site-header__top__menu button');

	siteFullNavButton.addEventListener('click', () => {
		siteHeader.classList.toggle('site-header--full-nav-visible');
		siteHeader.classList.remove('site-header--search-visible');
		document.body.classList.toggle('disable-page-scroll');
	})

	// Product image zoom.
	if (document.querySelector('.template-product')) {
		
		const productImageZoomTriggers = document.querySelectorAll('.product-image-zoom-trigger');
		const productImageZoom = document.querySelector('.product-image-zoom');
		
		productImageZoomTriggers.forEach(trigger => {
			trigger.addEventListener('click', (event) => {
				event.stopPropagation();
				productImageZoom.classList.toggle('product-image-zoom--visible');
				document.body.classList.toggle('disable-page-scroll');	
			});
		});
	}

	// Assortment filtering.
	if (document.querySelector('.assortment-filters')) {
		
		const assortmentFilterContainer = document.querySelector('.assortment-filters');
		const assortmentFilterTrigger = document.querySelector('.assortment-filters-trigger');
		const assortmentFilterClear = document.querySelector('.assortment-filters-clear');
		const assortmentSortingSelect = document.querySelector('select[name="assortment-sorting"]');
		const assortmentContainer = document.querySelector('#assortment');
		const assortmentFilterForm = document.querySelector('#assortment-filter');
		const assortmentFilterFields = assortmentFilterForm.querySelectorAll('details');
		const assortmentFilterFieldInputs = assortmentFilterForm.querySelectorAll('input[type="checkbox"], input[type="radio"]');
		const assortmentFilterSubmitButton = assortmentFilterForm.querySelector('input[type="submit"]');
		const assortmentFilterFormTitles = assortmentFilterForm.querySelectorAll('summary span');
		let assortmentFiltersUsed = {};
	
		// Assortment filter request.
		function assortmentFilterRequest() {
	
			const requestUrl = DOMPurify.sanitize(assortmentFilterForm.action + '?' + serialize(assortmentFilterForm));
	
			var url = new URL(requestUrl);
			var urlParams = url.searchParams;
	
			// Delete ajax parameter.
			urlParams.delete('assortment_ajax');
	
			// Convert search params to string.
			url.search = urlParams.toString();
			var historyUrl = url.toString();
	
	
			var xhr = new XMLHttpRequest();
			xhr.onreadystatechange = function () {
				if (xhr.readyState !== 4) return;
	
				if (xhr.status >= 200 && xhr.status < 300) {
	
					// Add response to assortment container.
					assortmentContainer.innerHTML = DOMPurify.sanitize(xhr.response);
	
					// Count products in response.
					const productsCount = assortmentContainer.querySelectorAll('.assortment-list__item');
	
					// Update submit button with products count.
					if ( productsCount.length ) {
						assortmentFilterSubmitButton.value = DOMPurify.sanitize(`Visa produkter (${productsCount.length})`);
						assortmentContainer.dataset.foundPosts = productsCount.length;

						// Update filter trigger counters.
						updateFilterTriggerCounter();
					} else {
						assortmentFilterSubmitButton.value = DOMPurify.sanitize(`Inga produkter hittades`);
						assortmentContainer.dataset.foundPosts = '';
					}
	
					// Update history state with new url.
					window.history.pushState(serialize(assortmentFilterForm), 'Sortiment &mdash; The Wine Team', DOMPurify.sanitize(historyUrl));
	
				} else {
					this.submit();
				}
			};
			xhr.open('GET', requestUrl);
			xhr.send();
		}
	
		// Handle assorment filter form change.
		assortmentFilterForm.addEventListener('change', assortmentFilterRequest);
	
		// Clear assortment filter.
		assortmentFilterClear.addEventListener('click', (event) => {
	
			// Uncheck all inputs.
			assortmentFilterFieldInputs.forEach(item => {
				item.checked = false;
			});
	
			// Update all filter titles.
			assortmentFilterFormTitles.forEach(title => {
				title.innerHTML = '';
			});

			// Close all details/summary elements.
			assortmentFilterFields.forEach(field => {
				field.removeAttribute('open');
			});
	
			// Update filter trigger counter.
			assortmentFiltersUsed = {};
			updateFilterTriggerCounter();
	
			// Trigger ajax request.
			assortmentFilterRequest();
		});
	
		// Assortment filter handle submit button.
		assortmentFilterForm.addEventListener('submit', (event) => {
			event.preventDefault();
			assortmentFilterContainer.classList.remove('assortment-filters--visible');
		});

		// Assortment filter handle trigger buttons.
		assortmentFilterTrigger.addEventListener('click', (event) => {

			// Update filters submit button products count.
			if ( assortmentContainer.dataset.foundPosts !== '0' ) {
				assortmentFilterSubmitButton.value = DOMPurify.sanitize(`Visa produkter (${assortmentContainer.dataset.foundPosts})`);
			} else {
				assortmentFilterSubmitButton.value = DOMPurify.sanitize(`Inga produkter hittades`);
			}

			// Show fields overlay.
			assortmentFilterContainer.classList.add('assortment-filters--visible');

			// Hide all fields.
			assortmentFilterFields.forEach(item => {
				item.open = false;
			});

			// Open selected field or scroll to first field.
			document.querySelector('#assortment-filter-producttype').scrollIntoView();
		});
		
		// Handle filter values click.
		assortmentFilterFieldInputs.forEach(input => {
			input.addEventListener('change', (event) => {

				// Update filter title counter.
				updateFilterTitleCounter(event);
	
				// Update filter trigger counters.
				updateFilterTriggerCounter();
			});
		});
			
		// Close assortment filters when clicked outside form.
		assortmentFilterContainer.addEventListener('click', (event) => {
			const isOutside = !event.target.closest('.assortment-filters__form');
			if (isOutside) {
				assortmentFilterContainer.classList.remove('assortment-filters--visible');
			}
		});
	
		// Handle assortment list sorting.
		assortmentSortingSelect.addEventListener('change', (event) => {
	
			const url = new URL(document.location.href);
			let urlParams = url.searchParams;
	
			// Delete pagination parameter.
			urlParams.delete('sida');
	
			// Add order parameter.
			urlParams.set('sortering', event.target.options[event.target.selectedIndex].value);
			
			// Convert search params to string.
			url.search = urlParams.toString();
			const new_url = url.toString();
	
			// Set location href to new url.
			window.location.href = DOMPurify.sanitize(new_url);
		});

		// Update filter title counter.
		function updateFilterTitleCounter(event) {
			const currentFilter = document.querySelector(`#assortment-filter-${event.target.dataset.filter}`);
			const currentFilterTitleCounter = currentFilter.querySelector('summary span');
			const inputs = currentFilter.querySelectorAll(`input[name="${event.target.name}"]:checked`);

			// Update filter title.
			if (inputs.length > 0) {
				currentFilterTitleCounter.innerHTML = DOMPurify.sanitize(`(${inputs.length})`);
				assortmentFiltersUsed[event.target.dataset.filter] = true;
			} else {
				currentFilterTitleCounter.innerHTML = '';
				delete assortmentFiltersUsed[event.target.dataset.filter];
			}
		}

		// Update filter trigger counter.
		function updateFilterTriggerCounter() {
			if (Object.keys(assortmentFiltersUsed).length > 0) {
				assortmentFilterTrigger.querySelector('span').innerHTML = `(${Object.keys(assortmentFiltersUsed).length})`;
			} else {
				assortmentFilterTrigger.querySelector('span').innerHTML = '';
			}
		}
	}

	// Expandable text in text block.
	const expandableTextBlockTriggers = document.querySelectorAll('.block-text__expandable-read-more button');
	expandableTextBlockTriggers.forEach(trigger => {
		trigger.addEventListener('click', (event) => {
			const expandableText = event.target.closest('.block-text--expandable').querySelector('.block-text__expandable-text');
			expandableText.classList.toggle('block-text__expandable-text--closed');

			if (event.target.innerText == event.target.dataset.labelReadMore) {
				event.target.innerText = event.target.dataset.labelMinimize;
			} else {
				event.target.innerText = event.target.dataset.labelReadMore;
			}
		})
	});

	// Expandable text in introduction block.
	const expandableIntroductionTextTriggers = document.querySelectorAll('.block-introduction__expandable-read-more button');
	expandableIntroductionTextTriggers.forEach(trigger => {
		trigger.addEventListener('click', (event) => {
			const expandableText = event.target.closest('.block-introduction--expandable').querySelector('.block-introduction__expandable-text');
			expandableText.classList.toggle('block-introduction__expandable-text--closed');

			if (event.target.innerText == event.target.dataset.labelReadMore) {
				event.target.innerText = event.target.dataset.labelMinimize;
			} else {
				event.target.innerText = event.target.dataset.labelReadMore;
			}
		})
	});
});
